<script>
export default {
    name: "ButtonInput",

    props: {
        disabled: {
            type: Boolean,
            default() {
                return false
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false
            }
        },
        text: {
            type: String,
            default() {
                return 'Button'
            }
        },
        type: {
            type: String,
            default() {
                return 'primary'
            }
        },
    }
}
</script>

<template>
    <button
        type="button"
        :class="`button-input button-input--${type}`"
        :disabled="disabled"
    >
        <template v-if="!loading">
            {{ text }}
        </template>
        <template v-if="loading">
            Loading...
        </template>
    </button>
</template>

<style lang="scss">
$bgColor: #51a2fe;
$bgHoverColor: #155dfd;
$textColor: #FFFFFF;

button.button-input {
    border: 2px solid transparent;
    font-size: 1rem;
    text-transform: uppercase;
    padding: .5rem 1.5rem;
    border-radius: .5rem;
    transition: .2s;

    &--primary {
        background: $bgColor;
        border-color: $bgColor;
        color: $textColor;

        &:hover {
            background: $bgHoverColor;
            border-color: $bgHoverColor;
        }

        &:active {
            background: $bgColor;
            border-color: $bgHoverColor;
        }
    }
}
</style>